import { useState, useRef } from 'react';
import { Col } from 'react-bootstrap';

import FilterServiceRequest from '../ServiceRequest/FilterServiceRequest/FilterServiceRequest';
import { useFilterPinned } from '../../hooks/usePinnedFilter';

import ApproverWorkReport from './ApproverWorkReport';
import '../ServiceRequest/ServiceRequest.scss';

const ApproverViewLayout = () => {
  const [showFilters, setShowFilters] = useState(false);
  const { isFilterPinned, setIsFilterPinned } = useFilterPinned();

  const hideModalFilters = () => {
    setShowFilters(false);
  };

  const fixedDrawerHeightRef = useRef(null);

  const contentCardClass = !isFilterPinned ? 'container-filter-resultGrilla' : 'inbox-height-calc';
  const onAnchor = () => {
    setIsFilterPinned(!isFilterPinned);
  };

  return (
    <>
      <div className="pas-container overflow-x-hidden">
        <div className={contentCardClass}>
          <FilterServiceRequest
            hideModal={hideModalFilters}
            isFilterPinned={isFilterPinned}
            onAnchor={onAnchor}
            ref={fixedDrawerHeightRef}
            show={showFilters}
            showAnchor
          />

          <Col className="container-title-table scrolled-table" ref={fixedDrawerHeightRef} sm={9}>
            <ApproverWorkReport setShowFilters={setShowFilters} />
          </Col>
        </div>
      </div>
    </>
  );
};

export default ApproverViewLayout;
